import { render, staticRenderFns } from "./charact.vue?vue&type=template&id=12f3b2e2&scoped=true"
import script from "./charact.vue?vue&type=script&lang=js"
export * from "./charact.vue?vue&type=script&lang=js"
import style0 from "./charact.vue?vue&type=style&index=0&id=12f3b2e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f3b2e2",
  null
  
)

export default component.exports